import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לריק",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה למלא.",
      "אני רק שם/ה לב לריק כמו שהוא.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה למלא.",
      "אני רק שם/ה לב לריק כמו שהוא.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הריק הזה הכי מורגש לי?",
      "מה קורה רגע לפני שהוא עולה?",
      "איך הוא מרגיש בגוף שלי?"
    ],
      [
      "מתי הריק הזה הכי מורגש לי?",
      "מה קורה רגע לפני שהוא עולה?",
      "איך הוא מרגיש בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב זה כבר קשר."
    ],
      [
      "לשים לב זה כבר קשר."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה נראה מבחוץ",
    opening: localizedGenderNode(
      [
      "היום אני רואה את הפער.",
      "בין מה שרואים בי למה שאני מרגיש/ה.",
      "רק לראות."
    ],
      [
      "היום אני רואה את הפער.",
      "בין מה שרואים בי למה שאני מרגיש/ה.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את כפות הרגליים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את כפות הרגליים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה נראה מבחוץ על החיים שלי?",
      "מה מרגיש אחרת בפנים?",
      "מה קשה לי לומר על הפער הזה?"
    ],
      [
      "מה נראה מבחוץ על החיים שלי?",
      "מה מרגיש אחרת בפנים?",
      "מה קשה לי לומר על הפער הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הפער לא אומר שאני מזויף/ת. הוא אומר שאני לא לבד בזה."
    ],
      [
      "הפער לא אומר שאני מזויף/ת. הוא אומר שאני לא לבד בזה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על הפער.",
      "לכתוב מילה אחת על הפער."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מתי זה התחיל",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת את תחילת הריק.",
      "בלי האשמה.",
      "רק סימן."
    ],
      [
      "היום אני מחפש/ת את תחילת הריק.",
      "בלי האשמה.",
      "רק סימן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי שמתי לב לזה לראשונה?",
      "מה קרה אז סביבי?",
      "מה השתנה בי מאז?"
    ],
      [
      "מתי שמתי לב לזה לראשונה?",
      "מה קרה אז סביבי?",
      "מה השתנה בי מאז?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לפעמים התחלה קטנה מסבירה הרבה."
    ],
      [
      "לפעמים התחלה קטנה מסבירה הרבה."
    ]
    ),
    action: localizedGenderNode(
      "לתת שם עדין להתחלה.",
      "לתת שם עדין להתחלה."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "מה חסר לי",
    opening: localizedGenderNode(
      [
      "היום אני שואל/ת מה חסר לי באמת.",
      "לא כדי להשיג.",
      "רק לזהות."
    ],
      [
      "היום אני שואל/ת מה חסר לי באמת.",
      "לא כדי להשיג.",
      "רק לזהות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה חסר לי ברגעים האלה?",
      "מה הייתי בוחר/ת/ה ולא קיבלתי?",
      "איזה צורך קטן מתעורר בי?"
    ],
      [
      "מה חסר לי ברגעים האלה?",
      "מה הייתי בוחר/ת/ה ולא קיבלתי?",
      "איזה צורך קטן מתעורר בי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צורך קטן הוא התחלה של קשר."
    ],
      [
      "צורך קטן הוא התחלה של קשר."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב צורך אחד בשקט.",
      "לכתוב צורך אחד בשקט."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הגנות שעובדות קשה",
    opening: localizedGenderNode(
      [
      "היום אני רואה את ההגנות שלי.",
      "מה הן מנסות לשמור.",
      "בלי לשפוט."
    ],
      [
      "היום אני רואה את ההגנות שלי.",
      "מה הן מנסות לשמור.",
      "בלי לשפוט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הכתפיים."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הכתפיים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה ההגנה העיקרית שלי מול הריק?",
      "מה היא מנסה למנוע ממני להרגיש?",
      "איך היא משפיעה על היום שלי?"
    ],
      [
      "מה ההגנה העיקרית שלי מול הריק?",
      "מה היא מנסה למנוע ממני להרגיש?",
      "איך היא משפיעה על היום שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם הגנה היא סימן לכאב."
    ],
      [
      "גם הגנה היא סימן לכאב."
    ]
    ),
    action: localizedGenderNode(
      "להגיד לעצמי \"אני רואה אותך\".",
      "להגיד לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "רגעים של חיות",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת רגעי חיות.",
      "גם קטנים.",
      "גם חולפים."
    ],
      [
      "היום אני מחפש/ת רגעי חיות.",
      "גם קטנים.",
      "גם חולפים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני מרגיש/ה את הידיים."
    ],
      [
      "אני נושם/ת.",
      "אני מרגיש/ה את הידיים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הרגשתי טיפת חיות לאחרונה?",
      "מה היה שם שעזר?",
      "מה אני יכול/ה להזמין עוד 1%?"
    ],
      [
      "מתי הרגשתי טיפת חיות לאחרונה?",
      "מה היה שם שעזר?",
      "מה אני יכול/ה להזמין עוד 1%?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם טיפת חיות משנה את הכיוון."
    ],
      [
      "גם טיפת חיות משנה את הכיוון."
    ]
    ),
    action: localizedGenderNode(
      "לזכור רגע כזה.",
      "לזכור רגע כזה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "fear",
    title: "בין ריק לעייפות",
    opening: localizedGenderNode(
      [
      "היום אני מבדיל/ה בין ריק לעייפות.",
      "אולי זה לא אותו דבר.",
      "אני בודק/ת."
    ],
      [
      "היום אני מבדיל/ה בין ריק לעייפות.",
      "אולי זה לא אותו דבר.",
      "אני בודק/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "האם אני עייף/ה או ריק/ה - או גם וגם?",
      "מה הגוף מבקש עכשיו?",
      "מה הייתי נותן/ת לו אילו יכולתי?"
    ],
      [
      "האם אני עייף/ה או ריק/ה - או גם וגם?",
      "מה הגוף מבקש עכשיו?",
      "מה הייתי נותן/ת לו אילו יכולתי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף לפעמים יודע לפני המחשבה."
    ],
      [
      "הגוף לפעמים יודע לפני המחשבה."
    ]
    ),
    action: localizedGenderNode(
      "להקשיב דקה אחת לגוף.",
      "להקשיב דקה אחת לגוף."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "need",
    title: "מילים שלא אמרתי",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שלא נאמר.",
      "זה גם חלק מהריק.",
      "אני איתי."
    ],
      [
      "היום אני שם/ה לב למה שלא נאמר.",
      "זה גם חלק מהריק.",
      "אני איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הגרון."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הגרון."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה לא אמרתי הרבה זמן?",
      "למי רציתי לומר משהו?",
      "מה הייתי אומר/ת לעצמי קודם?"
    ],
      [
      "מה לא אמרתי הרבה זמן?",
      "למי רציתי לומר משהו?",
      "מה הייתי אומר/ת לעצמי קודם?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מילים שלא נאמרו עדיין קיימות בי."
    ],
      [
      "מילים שלא נאמרו עדיין קיימות בי."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב משפט אחד שלא אמרתי.",
      "לכתוב משפט אחד שלא אמרתי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "need",
    title: "גבול שמגן",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת גבול קטן שמגן על הלב.",
      "בלי להסתגר.",
      "רק לשמור."
    ],
      [
      "היום אני מחפש/ת גבול קטן שמגן על הלב.",
      "בלי להסתגר.",
      "רק לשמור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הדופק."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הדופק."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני נותן/ת יותר מדי?",
      "איזה גבול קטן היה מקל עליי?",
      "איך אני יכול/ה לומר אותו לעצמי?"
    ],
      [
      "איפה אני נותן/ת יותר מדי?",
      "איזה גבול קטן היה מקל עליי?",
      "איך אני יכול/ה לומר אותו לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול קטן יכול להחזיר תחושה של אני."
    ],
      [
      "גבול קטן יכול להחזיר תחושה של אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט גבול אחד לעצמי.",
      "משפט גבול אחד לעצמי."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה אחת",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה אחת לעצמי.",
      "לא גדולה.",
      "פשוטה."
    ],
      [
      "היום אני מנסח/ת בקשה אחת לעצמי.",
      "לא גדולה.",
      "פשוטה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה עכשיו באמת?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "מה אני בוחר/ת/ה עכשיו באמת?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לפתוח דלת."
    ],
      [
      "בקשה אחת יכולה לפתוח דלת."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "perspective",
    title: "דבר קטן שמזין",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת משהו קטן שמזין אותי.",
      "לא כדי להשתנות.",
      "רק כדי לחזור."
    ],
      [
      "היום אני מחפש/ת משהו קטן שמזין אותי.",
      "לא כדי להשתנות.",
      "רק כדי לחזור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הבטן."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הבטן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה מזין אותי אפילו קצת?",
      "מתי עשיתי את זה לאחרונה?",
      "איך אני יכול/ה להזמין את זה היום?"
    ],
      [
      "מה מזין אותי אפילו קצת?",
      "מתי עשיתי את זה לאחרונה?",
      "איך אני יכול/ה להזמין את זה היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "משהו קטן יכול להזכיר לי שאני חי/ה."
    ],
      [
      "משהו קטן יכול להזכיר לי שאני חי/ה."
    ]
    ),
    action: localizedGenderNode(
      "לבחור דבר מזין אחד קטן.",
      "לבחור דבר מזין אחד קטן."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "strength",
    title: "לשבת עם עצמי",
    opening: localizedGenderNode(
      [
      "היום אני יושב/ת רגע עם עצמי.",
      "בלי צורך לעשות.",
      "רק להיות."
    ],
      [
      "היום אני יושב/ת רגע עם עצמי.",
      "בלי צורך לעשות.",
      "רק להיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני שם/ה לב לשקט."
    ],
      [
      "אני נושם/ת לאט.",
      "אני שם/ה לב לשקט."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה בי כשאני רק יושב/ת?",
      "מה הכי קשה לי בשקט הזה?",
      "מה כן מרכך אותי מעט?"
    ],
      [
      "מה קורה בי כשאני רק יושב/ת?",
      "מה הכי קשה לי בשקט הזה?",
      "מה כן מרכך אותי מעט?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להיות איתי לרגע הוא כבר שינוי קטן."
    ],
      [
      "להיות איתי לרגע הוא כבר שינוי קטן."
    ]
    ),
    action: localizedGenderNode(
      "ישיבה של דקה אחת עם נשימה.",
      "ישיבה של דקה אחת עם נשימה."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "strength",
    title: "אמירה רכה לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת אמירה רכה.",
      "לא גדולה.",
      "רק אמת קטנה."
    ],
      [
      "היום אני בוחר/ת אמירה רכה.",
      "לא גדולה.",
      "רק אמת קטנה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הייתי רוצה לשמוע עכשיו?",
      "איך זה נשמע כשזה נאמר לי?",
      "האם אני יכול/ה להגיד את זה לעצמי?"
    ],
      [
      "מה הייתי רוצה לשמוע עכשיו?",
      "איך זה נשמע כשזה נאמר לי?",
      "האם אני יכול/ה להגיד את זה לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "משפט רך יכול להיות חבל הצלה."
    ],
      [
      "משפט רך יכול להיות חבל הצלה."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט פעם אחת.",
      "לומר את המשפט פעם אחת."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לנוכחות.",
      "כשאני מתרוקן/ת.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לנוכחות.",
      "כשאני מתרוקן/ת.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הריק הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על הריק הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה לפגוש את הריק ולנשום בתוכו."
    ],
      [
      "אני יכול/ה לפגוש את הריק ולנשום בתוכו."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const everythingIsFineOnPaperButInsideIsEmptyBlueprintHe = buildNormalizedPilotBlueprint({
  id: "everything_is_fine_on_paper_but_inside_is_empty_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "everything_is_fine_on_paper_but_inside_is_empty",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "הכול בסדר על הנייר - ובפנים ריק",
    en: "Everything is fine on paper - but inside is empty",
    es: "Todo está bien en el papel, pero por dentro está vacío",
  },
  days,
});

export default everythingIsFineOnPaperButInsideIsEmptyBlueprintHe;
